import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios"


export const loadProductTags = async () => {
  try {
    const response = await Axios.get('product-tags');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};

const loadOneProduct = async (name) => {
  try {
    const respnse = await Axios.get('product-tags/'+name);
    const responseData = await respnse.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}

export const loadProductTag = async (action) => {
  try {
    switch (action) {
      case 'new':
        return {};
        
      default:
        const data = await loadOneProduct(action);
        return data;
    }
  }catch (err) {
    throw err;
  }
}

const useProductTagAPI = () => {
  
  const create = async (data, success) => {
    try {
      const respnse = await Axios.post('product-tags', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('productTag_response', data.seo);
    }catch(err) {
      throw err;
    }
  }

  const update = async (seo, data, success) => {
    try {
      const respnse = await Axios.put('product-tags/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
    }catch (err) {
      throw err;
    }
  }


  return { create, update };
};



export default useProductTagAPI;


